import { render, staticRenderFns } from "./ShowFinalReview.vue?vue&type=template&id=016b7570&scoped=true"
import script from "./ShowFinalReview.vue?vue&type=script&lang=js"
export * from "./ShowFinalReview.vue?vue&type=script&lang=js"
import style0 from "./ShowFinalReview.vue?vue&type=style&index=0&id=016b7570&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "016b7570",
  null
  
)

export default component.exports